import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'oliver_display_name';
const DEFAULT_NAME = 'Oliver';

const OliverContext = createContext(null);

export function OliverProvider({ children }) {
  const [oliverName, setOliverNameState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_NAME;
    } catch {
      return DEFAULT_NAME;
    }
  });

  const setOliverName = useCallback((name) => {
    const value = (name && String(name).trim()) || DEFAULT_NAME;
    setOliverNameState(value);
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {}
  }, []);

  return (
    <OliverContext.Provider value={{ oliverName, setOliverName }}>
      {children}
    </OliverContext.Provider>
  );
}

export function useOliverName() {
  const ctx = useContext(OliverContext);
  if (!ctx) {
    return { oliverName: DEFAULT_NAME, setOliverName: () => {} };
  }
  return ctx;
}

export default OliverContext;
